import { Card, CardActionArea, CardContent, CardMedia, Typography } from "@material-ui/core";
import { Link, useHistory } from "react-router-dom";

import { useStyles } from './styles';

function HomeCard({ title, description, src, pathname, mailto }) {
  const classes = useStyles();
  let history = useHistory();

  function handleChangePath(path) {
    history.push(path);
  }
  
  return (
    <>
    {mailto ? (
      <Card 
        onClick={() => handleChangePath(pathname)} 
        className={classes.card}
      >
        <Link 
          className={classes.link}
          to="#"
          onClick={(e) => {
            window.location = mailto;
            e.preventDefault();
        }}
        >
          <CardActionArea>
            <CardMedia
              component="img"
              className={classes.media}
              image={src}
              title={title}
              alt={title}
            />
            <CardContent>
              <Typography gutterBottom variant="h2" component="h2" className={classes.title}>
                {title}
              </Typography>
              <Typography variant="body2" component="p">
                {description}
              </Typography>
            </CardContent>
          </CardActionArea>
        </Link>
      </Card>
    ) : (
      <Card 
        onClick={() => handleChangePath(pathname)} 
        className={classes.card}
      >
        <CardActionArea>
          <CardMedia
            component="img"
            className={classes.media}
            image={src}
            title={title}
            alt={title}
          />
          <CardContent>
            <Typography gutterBottom variant="h2" component="h2" className={classes.title}>
              {title}
            </Typography>
            <Typography variant="body2" component="p">
              {description}
            </Typography>
          </CardContent>
        </CardActionArea>
      </Card>
    )}
    </>
  );
}

export default HomeCard;